import FormField from 'components/CreationForms/base/FormField';
import { TagsBoxShowAllView } from 'components/TagsBoxShowAll/TagsBoxShowAllView';
import { ExternalProperty } from 'crono-fe-common/types/externalProperty';
import InputExternalPropertyNotTag from 'pages/accountDrawer/externalPropertyNotTag/inputExternalPropertyNotTag';
import { getExternalPropertyInputKey } from 'utils/businessLogic';

interface CustomFieldsProps {
  /** Custom fields that aren't tags, one input each. */
  properties?: ExternalProperty[];
  tags?: ExternalProperty[];
  values: Record<number, string>;
  onChange?: (propertyId: number, value: string) => void;
  onTagClick?: (option: string | null, tag: ExternalProperty) => void;
}

/** Custom field inputs, then the tags, as the creation forms show them. Values are matched by property id. */
const CustomFields = ({
  properties = [],
  tags = [],
  values,
  onChange,
  onTagClick,
}: CustomFieldsProps) => {
  const externalValues = Object.entries(values).map(([id, value]) => ({
    externalPropertyId: Number(id),
    value,
  }));
  const currentSituationTags = tags.flatMap((tag) =>
    values[tag.id]
      ? [{ externalPropertyId: tag.id, option: values[tag.id] }]
      : [],
  );

  return (
    <>
      {onChange &&
        properties.map((property) => (
          <CustomField
            // Remounts the input when a value appears or goes, so its local
            // draft follows it.
            key={getExternalPropertyInputKey(property.id, externalValues)}
            property={property}
            value={values[property.id]}
            onChange={onChange}
          />
        ))}
      {onTagClick && tags.length > 0 && (
        <TagsBoxShowAllView
          tags={tags}
          currentSituationTags={currentSituationTags}
          handleClickTag={onTagClick}
          showMandatoryAsStar
          customStyle={{ height: '2rem' }}
          className="gap-3!"
        />
      )}
    </>
  );
};

interface CustomFieldProps {
  property: ExternalProperty;
  value: string | undefined;
  onChange: (propertyId: number, value: string) => void;
}

const CustomField = ({ property, value, onChange }: CustomFieldProps) => (
  <FormField label={property.publicName ?? ''} required={property.isMandatory}>
    <InputExternalPropertyNotTag
      externalProperty={property}
      externalValue={
        value === undefined ? null : { externalPropertyId: property.id, value }
      }
      owned
      showLabel={false}
      handleSetValue={onChange}
    />
  </FormField>
);

export default CustomFields;
